import type { Filter } from '@/entities/station';
import type { StationWithSaving } from '../model/stationWithSaving.schema';

const sortStations = (
	stations: StationWithSaving[],
	sortBy: Filter,
): StationWithSaving[] => {
	const sorted = [...stations];

	switch (sortBy) {
		case 'distance':
			return sorted.sort((a, b) => {
				const aDist = a.distanceFromUser ?? Number.POSITIVE_INFINITY;
				const bDist = b.distanceFromUser ?? Number.POSITIVE_INFINITY;
				return aDist - bDist;
			});
		case 'price':
			return sorted.sort((a, b) => a.price - b.price);
		case 'savings':
			return sorted.sort((a, b) => {
				const aSavings = a.savings ?? Number.NEGATIVE_INFINITY;
				const bSavings = b.savings ?? Number.NEGATIVE_INFINITY;
				if (aSavings !== bSavings) return bSavings - aSavings;

				const aDist = a.distanceFromUser ?? Number.POSITIVE_INFINITY;
				const bDist = b.distanceFromUser ?? Number.POSITIVE_INFINITY;
				return aDist - bDist;
			});
	}
};

export default sortStations;
